import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative flex items-start"
}
const _hoisted_2 = { class: "flex h-6 items-center" }
const _hoisted_3 = ["id", "aria-describedby", "name", "disabled"]
const _hoisted_4 = { class: "ml-3 text-sm leading-6" }
const _hoisted_5 = ["for"]
const _hoisted_6 = { class: "" }
const _hoisted_7 = ["id"]
const _hoisted_8 = ["id"]
const _hoisted_9 = {
  key: 1,
  class: "mt-2 block"
}
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = ["id", "name", "disabled"]
const _hoisted_13 = ["id", "innerHTML"]
const _hoisted_14 = ["for", "id"]
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "relative z-50" }
const _hoisted_17 = ["id"]
const _hoisted_18 = ["id"]

import { ref } from "vue";
import { defineEmits } from "@vue/runtime-core";
import { DynamicProperty } from "@/models/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputPeriodCheckbox',
  props: {
  model: {
    type: Object as () => DynamicProperty,
    required: true,
  },
  id: String,
  label: String,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;
let model = ref(props.model);

function customChange() {
  emit("change", model.value);
}
function getPeriodTime(item: DynamicProperty) {
  if (item.data?.startDate && item.data?.endDate) {
    // Fix corrupted startDate containing two dates (e.g. "2026-02-14 2026-02-20")
    const corruptMatch = item.data.startDate.match?.(/^(\d{4}-\d{2}-\d{2})\s+(\d{4}-\d{2}-\d{2})$/);
    if (corruptMatch) {
      return `${corruptMatch[1]} - ${item.data.endDate}`;
    }
    return `${item.data.startDate} - ${item.data.endDate}`;
  }
  return parseDatesFromLabel(item.label);
}

function parseDatesFromLabel(label: string | undefined): string {
  if (!label) return "";
  const match = label.match(/(\d{4}-\d{2}-\d{2})\s*-?\s*(\d{4}-\d{2}-\d{2})/);
  if (match) {
    return `${match[1]} - ${match[2]}`;
  }
  return label;
}
const showingErrorMessage = ref(false);

const showErrorMessage = () => {
  showingErrorMessage.value = true;
};
const hideErrorMessage = () => {
  showingErrorMessage.value = false;
};

return (_ctx: any,_cache: any) => {
  return (props.adminView)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            id: _unref(model).key,
            "aria-describedby": `${_unref(model).label}-description`,
            name: _unref(model).key,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).data.checked) = $event)),
            disabled: props.disabled,
            onChange: customChange,
            type: "checkbox",
            class: "h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
          }, null, 40, _hoisted_3), [
            [_vModelCheckbox, _unref(model).data.checked]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", {
            for: _unref(model).key,
            class: "mt-1 text-sm text-gray-900"
          }, _toDisplayString(getPeriodTime(_unref(model))), 9, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "bg-white rounded-md my-2",
            id: 'outer-error_' + _unref(model).key
          }, [
            _createElementVNode("p", {
              class: "font-medium text-sm text-red-2",
              id: 'error_' + _unref(model).key
            }, null, 8, _hoisted_8)
          ], 8, _hoisted_7)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        _createElementVNode("label", {
          for: _unref(model).key,
          "data-dashlane-label": "true"
        }, [
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              class: "disabled:bg-gray-2 disabled:text-gray-2 disabled:cursor-not-allowed disabled:border-gray-2",
              type: "checkbox",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).data.checked) = $event)),
              onChange: customChange,
              id: __props.id,
              name: _unref(model).key,
              disabled: props.disabled ? true : null
            }, null, 40, _hoisted_12), [
              [_vModelCheckbox, _unref(model).data.checked]
            ]),
            (_unref(model).isHtml)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "px-2",
                  id: 'inner-text_' + _unref(model).key,
                  innerHTML: _unref(model).label
                }, null, 8, _hoisted_13))
              : _createCommentVNode("", true),
            (!_unref(model).isHtml)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 1,
                  for: _unref(model).key,
                  class: "px-2",
                  id: 'inner-text_' + _unref(model).key
                }, _toDisplayString(_unref(model).label), 9, _hoisted_14))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              id: 'icon-error_' + _unref(model).key,
              class: "hidden absolute top-[3px] right-0 left-auto w-[20px] flex flex-row justify-center items-center",
              onMouseenter: showErrorMessage,
              onMouseleave: hideErrorMessage
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "text-red-2 fa-solid fa-circle-info" }, null, -1)
            ]))], 40, _hoisted_15)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: "absolute top-0 left-0 right-0 bottom-auto bg-white rounded-md p-2 shadow-md",
              id: 'outer-error_' + _unref(model).key
            }, [
              _createElementVNode("p", {
                class: "font-medium text-sm text-red-2",
                id: 'error_' + _unref(model).key
              }, null, 8, _hoisted_18)
            ], 8, _hoisted_17)
          ], 512), [
            [_vShow, showingErrorMessage.value]
          ])
        ], 8, _hoisted_10)
      ]))
}
}

})